import { FileInput, Input, InputWrapperProps, NumberInputProps, PasswordInput, PasswordInputProps, PinInputProps, TextInput, TextInputProps } from "@mantine/core";
import { useEffect, useRef, useState } from "react";
import { useFormHelperContext } from "../form";
import { useFormState } from "react-hook-form";
import { InputWrapper } from "../inputWrapper";

export interface FieldInputPinProps extends PinInputProps {
    label: string;
    name: string;
    resolver: (file: File | File[]) => string;
    multiple?: boolean;
    inputWrapper?: InputWrapperProps;
    withAsterisk?: boolean;
}

export const FieldInputPin: React.FC<FieldInputPinProps> = ({ label, inputWrapper, name, resolver, multiple = false, ...rest }) => {
    const { register, control, formStore, setValue } = useFormHelperContext();
    const { errors } = useFormState({ control });
    const inputRef = useRef<HTMLInputElement | null>(null);
    const isFocused = useRef(false);
    const [valuePlaceholder, setValuePlaceholder] = useState<number | string>(0);
    if (!register) {
        throw new Error("Field.Text must be used within a FormHelper component");
    }
    if (!resolver) {
        throw new Error("Resolver must be provided");
    }

    useEffect(() => {
        if (isFocused.current && inputRef.current) {
            inputRef.current.focus();
        }
    }, [errors]);

    return (
        <InputWrapper label={label} {...inputWrapper} withAsterisk={rest.withAsterisk}>
            <div className="flex flex-col w-full">
                <FileInput
                    multiple={multiple}
                    data-testid={'field-pin-' + name}
                    leftSectionPointerEvents="none"
                    readOnly={formStore.readOnly}
                    onChange={(event) => {
                        if (event === null) {
                            return;
                        }
                        const value = resolver(event)
                        setValue(name, value);
                    }}
                />
                {typeof errors[name]?.message === 'string' && <Input.Error>{errors[name]?.message}</Input.Error>}
            </div>
        </InputWrapper>
    );
};
